(() => {
  'use strict';
  const config = window.VareumCatalog || { categories: [] };
  const categoryById = id => config.categories.find(item => item.id === id);
  const quote = term => JSON.stringify(term);
  const cleanSku = term => term.replace(/^(.+?)\s+OR\s+sku:\1\s*$/i, '$1');
  function setupSearch(root = document) {
    root.querySelectorAll('form[data-vareum-search]').forEach(form => {
      if (form.dataset.vrReady) return;
      form.dataset.vrReady = 'true';
      const input = form.querySelector('input[name="q"]');
      const select = form.querySelector('[data-vareum-category]');
      if (!input) return;
      const params = new URLSearchParams(location.search);
      if (location.pathname.endsWith('/search') && params.has('vr_term')) input.value = params.get('vr_term');
      if (select && categoryById(params.get('vr_category'))) select.value = params.get('vr_category');
      form.addEventListener('submit', event => {
        const term = cleanSku(input.value.trim());
        const mobileHeader = form.closest('.header') && window.matchMedia('(max-width: 1023px)').matches;
        const category = mobileHeader ? undefined : categoryById(select?.value);
        if (!term && !category) return;
        event.preventDefault();
        const url = new URL(form.action, location.origin);
        let expression = term;
        if (term && /^[\w.\-+/]+$/.test(term) && term.length >= 2) expression = `(${quote(term)} OR sku:${quote(term)})`;
        else if (term) expression = `(${term})`;
        if (category) expression = category.query + (expression ? ` AND ${expression}` : '');
        url.searchParams.set('q', expression);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('vr_term', term);
        if (category) url.searchParams.set('vr_category', category.id);
        location.assign(url.href);
      });
    });
  }
  function setupDirectory(root = document) {
    root.querySelectorAll('[data-vr-directory]').forEach(directory => {
      if (directory.dataset.vrReady) return;
      directory.dataset.vrReady = 'true';
      const search = directory.querySelector('#vr-brand-search');
      const catalog = directory.querySelector('[data-vr-catalog-only]');
      const cards = [...directory.querySelectorAll('.vr-brand')];
      const buttons = [...directory.querySelectorAll('[data-vr-letter]')];
      const letters = new Set(cards.map(card => card.dataset.brandLetter));
      let selected = 'all';
      buttons.forEach(button => { if (button.dataset.vrLetter !== 'all' && !letters.has(button.dataset.vrLetter)) button.disabled = true; });
      function filter() {
        const term = search.value.trim().toLocaleLowerCase();
        let count = 0;
        cards.forEach(card => {
          const visible = card.dataset.brandName.includes(term) && (selected === 'all' || card.dataset.brandLetter === selected) && (!catalog.checked || card.dataset.brandCatalog === 'true');
          card.hidden = !visible;
          if (visible) count++;
        });
        directory.querySelector('[data-vr-count]').textContent = count;
        directory.querySelector('[data-vr-empty]').hidden = count !== 0;
      }
      search.addEventListener('input', filter);
      catalog.addEventListener('change', filter);
      buttons.forEach(button => button.addEventListener('click', () => {
        selected = button.dataset.vrLetter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        filter();
      }));
      directory.querySelector('[data-vr-clear]').addEventListener('click', () => {
        selected = 'all'; search.value = ''; catalog.checked = false;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.vrLetter === 'all')));
        filter(); search.focus();
      });
      filter();
    });
  }
  function setupMotion(root = document) {
    root.querySelectorAll('[data-vr-marquee]').forEach(band => {
      if (band.dataset.vrReady) return;
      band.dataset.vrReady = 'true';
      const button = band.querySelector('[data-vr-motion]');
      button.addEventListener('click', () => {
        const paused = band.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-vr-motion-label]').textContent = paused ? button.dataset.resume : button.dataset.pause;
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => band.toggleAttribute('data-offscreen', !entry.isIntersecting)), { rootMargin: '150px' });
        observer.observe(band);
      }
    });
  }
  function improveSearchContext() {
    const params = new URLSearchParams(location.search);
    if (!location.pathname.endsWith('/search') || !params.has('vr_category')) return;
    const category = categoryById(params.get('vr_category'));
    if (!category) return;
    const original = params.get('q');
    const label = [params.get('vr_vendor'), category.label, params.get('vr_term')].filter(Boolean).join(' · ');
    const heading = document.querySelector('main h1');
    if (heading) heading.textContent = label;
    document.querySelectorAll('h1, .template-search__header, #ProductCount').forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) { if (original && node.textContent.includes(original)) node.textContent = node.textContent.split(original).join(label); }
    });
    document.querySelectorAll('form[data-vareum-search] input[name="q"]').forEach(input => input.value = params.get('vr_term') || '');
  }
  function init(root = document) { setupSearch(root); setupDirectory(root); setupMotion(root); }
  init();
  improveSearchContext();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
